if (window.BSS_BCP_V2?.r4q?.logics?.length ) {

  document.addEventListener('bcpR4q:openForm', () => {
    setTimeout(() => {
      const wrapper = document.querySelector('bcp-r4q-form-wrapper');
      const formMainRoot = wrapper?.shadowRoot?.querySelector('bcp-r4q-form-main')?.shadowRoot;
      if (!formMainRoot) return;

      const productList = formMainRoot.querySelector('.product-list');
      if (!productList) return;

      // Tránh dựng lại row/observer trùng khi modal mở lại (event bắn lại mỗi lần mở)
      if (formMainRoot.getElementById('bcp-custom-r4q-summary')) return;

      const summaryWrapper = document.createElement('div');
      summaryWrapper.id = 'bcp-custom-r4q-summary';
      summaryWrapper.style.borderTop = '1px solid #e1e1e1';
      summaryWrapper.style.marginTop = '8px';
      summaryWrapper.style.paddingTop = '8px';

      function createRow(id, label, bold) {
        const row = document.createElement('div');
        row.id = id;
        row.style.display = 'flex';
        row.style.justifyContent = 'space-between';
        row.style.fontSize = bold ? '16px' : '14px';
        row.style.fontWeight = bold ? '700' : '400';
        row.style.padding = '4px 0';
        const labelEl = document.createElement('span');
        labelEl.textContent = label;
        const valueEl = document.createElement('span');
        valueEl.className = id + '-value';
        row.appendChild(labelEl);
        row.appendChild(valueEl);
        return row;
      }

      const subtotalRow = createRow('bcp-custom-r4q-subtotal-row', 'Subtotal', false);
      const totalRow = createRow('bcp-custom-r4q-total-row', 'Order total', true);
      summaryWrapper.appendChild(subtotalRow);
      summaryWrapper.appendChild(totalRow);
      productList.insertAdjacentElement('afterend', summaryWrapper);

      const subtotalValueEl = subtotalRow.querySelector('.bcp-custom-r4q-subtotal-row-value');
      const totalValueEl = totalRow.querySelector('.bcp-custom-r4q-total-row-value');

      // Bảng quy tắc format tiền theo đúng key placeholder BSS dùng trong money_format
      const MONEY_FORMAT_MAP = {
        amount: { precision: 2, decimal: '.', thousands: ',' },
        amount_no_decimals: { precision: 0, decimal: '.', thousands: ',' },
        amount_with_comma_separator: { precision: 2, decimal: ',', thousands: '.' },
        amount_no_decimals_with_comma_separator: { precision: 0, decimal: ',', thousands: '.' },
        amount_with_period_separator: { precision: 2, decimal: '.', thousands: ',' },
        amount_with_apostrophe_separator: { precision: 2, decimal: '.', thousands: "'" },
        amount_with_space_separator: { precision: 2, decimal: ',', thousands: ' ' },
        amount_no_decimals_with_space_separator: { precision: 0, decimal: ' ', thousands: ' ' },
      };

      // Chuẩn formatMoneySupport của BSS, nhận amount ở đơn vị tiền tệ (không phải cents)
      function formatMoneySupport(amount, decimalCount = 2, decimal = '.', thousands = ',') {
        decimalCount = Number.isFinite(decimalCount) ? Math.abs(decimalCount) : 2;
        const negativeSign = amount < 0 ? '-' : '';
        const absAmount = Math.abs(amount);
        const formattedAmount = absAmount.toFixed(decimalCount);
        const parts = formattedAmount.split('.');
        let integer = parts[0];
        const fraction = parts[1];
        integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return negativeSign + integer + (decimalCount ? decimal + fraction : '');
      }

      // Đọc money_format thật của app Quotes: window.BSS_BCP_V2.store.moneyFormat
      function getMoneyFormatConfig() {
        const format = window.BSS_BCP_V2?.shop?.moneyFormat || '${{amount}}';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const match = format.match(placeholderRegex);
        const key = match ? match[1] : 'amount';
        const rule = MONEY_FORMAT_MAP[key] || MONEY_FORMAT_MAP.amount;
        return { format, placeholderRegex, rule };
      }

      function formatMoneyBSS(amount) {
        const { format, placeholderRegex, rule } = getMoneyFormatConfig();
        const value = formatMoneySupport(amount, rule.precision, rule.decimal, rule.thousands);
        return format.replace(placeholderRegex, value);
      }

      // Đọc ngược chuỗi giá đã format (vd "€1.448,90") ra number, đúng cặp
      // decimal/thousands theo money_format hiện tại
      function parseLocalizedMoney(text) {
  const { rule } = getMoneyFormatConfig();
  let s = String(text).replace(/[^\d.,-]/g, ''); // bỏ ký hiệu tiền, khoảng trắng, dấu '
  const sign = s.includes('-') ? -1 : 1;
  s = s.replace(/-/g, '');

  // Format không có số lẻ (VND, JPY...): mọi dấu đều là phân cách nghìn
  if (rule.noDecimals) return sign * Number(s.replace(/\D/g, ''));

  const lastSep = Math.max(s.lastIndexOf('.'), s.lastIndexOf(','));
  if (lastSep === -1) return sign * Number(s);

  const sepChar = s[lastSep];
  const tail = s.slice(lastSep + 1);
  const sepCount = s.split(sepChar).length - 1;

  // Dấu cuối là thập phân nếu chỉ xuất hiện 1 lần và theo sau là 1-2 chữ số
  const isDecimal = sepCount === 1 && tail.length > 0 && tail.length <= 2;

  const intPart = (isDecimal ? s.slice(0, lastSep) : s).replace(/\D/g, '');
  return sign * Number(isDecimal ? `${intPart}.${tail}` : intPart);
}

      const observedLineItems = new WeakSet();

      function computeSubtotal() {
        const lineItems = productList.querySelectorAll('bcp-r4q-line-item');
        let subtotal = 0;
        let hasPendingPrice = false;

        lineItems.forEach(function (lineItem) {
          if (!observedLineItems.has(lineItem) && lineItem.shadowRoot) {
            const lineItemObserver = new MutationObserver(recalcSummary);
            lineItemObserver.observe(lineItem.shadowRoot, { subtree: true, childList: true, characterData: true });
            observedLineItems.add(lineItem);
          }
          const quotedTotalEl = lineItem.shadowRoot?.querySelector('.total-price .quoted-total');
          if (!quotedTotalEl) { hasPendingPrice = true; return; }
          const price = parseLocalizedMoney(quotedTotalEl.textContent);
          if (Number.isNaN(price)) { hasPendingPrice = true; return; }
          subtotal += price;
        });

        return { subtotal, hasPendingPrice };
      }

      // Order total = Subtotal (R4Q hiện chưa có phụ phí/thuế/discount cấp đơn hàng)
      function computeOrderTotal(subtotal) {
        return subtotal;
      }

      function recalcSummary() {
        const { subtotal, hasPendingPrice } = computeSubtotal();
        const orderTotal = computeOrderTotal(subtotal);
        const pendingSuffix = hasPendingPrice ? ' (calculando...)' : '';
        const subtotalText = formatMoneyBSS(subtotal) + pendingSuffix;
        const totalText = formatMoneyBSS(orderTotal) + pendingSuffix;
        if (subtotalValueEl.textContent !== subtotalText) subtotalValueEl.textContent = subtotalText;
        if (totalValueEl.textContent !== totalText) totalValueEl.textContent = totalText;
      }

      recalcSummary();
      new MutationObserver(recalcSummary).observe(productList, { childList: true, subtree: true });
    }, 500);
  });
}